<template>
  <div class="edit">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item href="/user/userTrackList">学员跟踪记录</Breadcrumb-item>
        <Breadcrumb-item>添加跟踪记录-教材配送记录</Breadcrumb-item>
      </Breadcrumb>
    </div>

    <Form ref="form" :model="formValidate" :rules="ruleValidate" :label-width="90" class="form">
      <Row>
        <Col :sm="11" :md="4">
          <Form-item label="学生ID" prop="uid">
            <Input readonly v-model.number="formValidate.uid"></Input>
          </Form-item>
        </Col>
        <Col :sm="11" :md="6">
          <Form-item label="学生姓名" prop="nickname">
            <Input readonly v-model="formValidate.nickname"></Input>
          </Form-item>
        </Col>
        <Col :sm="11" :md="6">
          <Form-item label="课程顾问" prop="adviserName">
            <Input readonly v-model="formValidate.adviserName"></Input>
          </Form-item>
        </Col>
        <Col :sm="11" :md="6">
          <Form-item label="学习导师" prop="studyAdviserName">
            <Input readonly v-model="formValidate.studyAdviserName"></Input>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <i-col :span="16">
          <Form-item label="寄送教材" prop="bookMaterialLevel">
            <Select v-model="formValidate.bookMaterialLevel" filterable clearable multiple>
              <OptionGroup label="Pre">
                <Option value="Pre 1">Pre 1</Option>
                <Option value="Pre 2">Pre 2</Option>
                <Option value="Pre 3">Pre 3</Option>
                <Option value="Pre 4">Pre 4</Option>
                <Option value="Pre 5">Pre 5</Option>
                <Option value="Pre 6">Pre 6</Option>
              </OptionGroup>
              <OptionGroup label="Phonics">
                <Option value="Phonics 1">Phonics 1</Option>
                <Option value="Phonics 2">Phonics 2</Option>
                <Option value="Phonics 3">Phonics 3</Option>
                <Option value="Phonics 4">Phonics 4</Option>
                <Option value="Phonics 5">Phonics 5</Option>
                <Option value="Phonics 6">Phonics 6</Option>
              </OptionGroup>
              <OptionGroup label="G">
                <Option value="G-1A">G-1A</Option>
                <Option value="G-1B">G-1B</Option>
                <Option value="G-2A">G-2A</Option>
                <Option value="G-2B">G-2B</Option>
                <Option value="G-3A">G-3A</Option>
                <Option value="G-3B">G-3B</Option>
                <Option value="G-4A">G-4A</Option>
                <Option value="G-4B">G-4B</Option>
                <Option value="G-5A">G-5A</Option>
                <Option value="G-5B">G-5B</Option>
                <Option value="G-6A">G-6A</Option>
                <Option value="G-6B">G-6B</Option>
              </OptionGroup>
              <OptionGroup label="JS">
                <Option value="JS1A">JS1A</Option>
                <Option value="JS1B">JS1B</Option>
                <Option value="JS2A">JS2A</Option>
                <Option value="JS2B">JS2B</Option>
                <Option value="JS3A">JS3A</Option>
                <Option value="JS3B">JS3B</Option>
              </OptionGroup>
              <OptionGroup label="Wonders">
                <Option value="Wonders 无教材">Wonders 无教材</Option>
              </OptionGroup>

            </Select>
          </Form-item>
        </i-col>
        <i-col :span="4" :offset="1">
          <Button icon="trash-a" @click="allClear">清空教材</Button>
        </i-col>
        <i-col :span="22">
          <Form-item label="邮寄地址" prop="address">
            <Input v-model="formValidate.address" type="textarea" :autosize="{minRows: 2,maxRows: 4}" placeholder="必填"/>
          </Form-item>
        </i-col>
      </Row>
      <Row>
        <Col :sm="11" :md="9">
          <Form-item label="下次联系日期" prop="nextHandlerTime">
            <Date-picker type="date" format="yyyy-MM-dd" @on-change="nextTimeDateChange"
              :value="formValidate.nextHandlerTime"></Date-picker>
          </Form-item>
        </Col>
        <Col :sm="11" :md="7">
          <Form-item label="下次联系人" prop="nextHandlerId">
            <Select v-model.number="formValidate.nextHandlerId" filterable>
              <Option v-for="item in nextHandler"
                :value="item.id" :key="item.id">{{ item.nickname }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :sm="11" :md="6">
        <Form-item label="状态" prop="operateStatus">
          <Select v-model="formValidate.operateStatus">
            <Option value="0">未处理</Option>
            <Option value="1">已处理</Option>
          </Select>
        </Form-item>
        </Col>
      </Row>
      <Form-item>
        <Button type="primary" @click="handleSubmit()">提交</Button>
      </Form-item>
    </Form>
  </div>
</template>
<script>
  import dates from '@/tools/date/dates.js'
  export default {
    data () {
//      let $moment = this.$moment
      return {
        nextHandler: [],
        uidReadonly: false,
        formValidate: {
          id: '',
          uid: null,
          nickname: '',
          adviserName: '',
          studyAdviserName: '',
          content: '',
          nextHandlerTime: dates.today(),
          nextHandlerId: null,
          operateStatus: '0',
          bookMaterialLevel: [],
          address: '',
          fundPackageId: null,
        },
        ruleValidate: {
          uid: [
            { type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' },
            { pattern: /^[0-9]+$/, message: '学生ID只能为数字', trigger: 'blur' },
          ],
          content: [
            { required: true, message: '内容不能为空', trigger: 'blur' },
            { type: 'string', max: 200, message: '内容不能超过200个字', trigger: 'blur' }
          ],
          bookMaterialLevel: [
            { type: 'array', required: true, message: '请选择教材', trigger: 'blur' },
          ],
          address: [
            { required: true, message: '地址不能为空', trigger: 'blur' },
            { type: 'string', max: 200, message: '地址不能超过200个字', trigger: 'blur' }
          ],
        },
      }
    },
    created () {

    },
    mounted () {
      let self = this
      let formValidate = this.formValidate
      formValidate.uid = this.$route.query.row.uid
      this.$http.post('/adminUser/listByCondition', {status: 1}).then(function (res) {
        self.nextHandler = res.data
      })

      this.getUserInfo()
      this.getFundPackageData()
    },
    methods: {
      nextTimeDateChange (value) {
        this.formValidate.nextHandlerTime = value
        console.log(this.formValidate.nextHandlerTime)
      },
      getUserInfo () {
        let self = this
        if (!self.formValidate.uid) {
          return
        }
        self.$http.post('/user/queryById', {'uid': self.formValidate.uid}).then(function (res) {
          if (!res || !res.data) {
            return
          }
          let user = res.data
          self.formValidate.nickname = user.nickname
          self.formValidate.adviserName = user.adviserName
          self.formValidate.studyAdviserName = user.studyAdviserName
        })
      },
      getFundPackageData () {
        let self = this
        if (!self.formValidate.uid) {
          return
        }
        self.$http.post('/fundPackage/list', {'uid': self.formValidate.uid, 'pageIndex': 1, 'pageSize': 1}).then(function (res) {
          if (!res || !res.data) {
            return
          }
          let fundPackageData = res.data.data[0]
          self.formValidate.address = fundPackageData.address
          self.formValidate.bookMaterialLevel = fundPackageData.bookMaterialLevel
          self.formValidate.fundPackageId = fundPackageData.id
        })
      },
      handleSubmit () {
        let self = this
        this.$refs.form.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            return
          }

          self.$http.post('/userTrack/addSendMaterialRecords', self.formValidate).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('提交成功!')
              self.$router.push('/user/userTrackList')
            }
          })
        })
      },
      allClear () {
        this.formValidate.bookMaterialLevel = []
      }
    },
    watch: {
    }
  }
</script>



// WEBPACK FOOTER //
// AddSendMaterialRecords.vue?0bb8f868